export class SilentModeSlot {
  start_hour: number
  start_minute: number
  end_hour: number
  end_minute: number

  constructor (start_hour: number, start_minute: number, end_hour: number, end_minute: number) {
    this.start_hour = start_hour
    this.start_minute = start_minute
    this.end_hour = end_hour
    this.end_minute = end_minute
  }
}

export class DeviceOptions {
  volume_percent: number
  time_seq_enabled: boolean
  silent_mode: SilentModeSlot[]
  readonly dirty: boolean

  constructor (volume_percent: number, time_seq_enabled: boolean, silent_mode: SilentModeSlot[], dirty: boolean) {
    this.volume_percent = volume_percent
    this.time_seq_enabled = time_seq_enabled
    this.silent_mode = silent_mode
    this.dirty = dirty
  }
}
